export const AutoPaySection = {
  path: '/auto_pay_sections',
  name: 'auto_pay_sections',
  component: () => import('@/views/AutoPaySection/AutoPaySectionPage.vue'),
  children: [
    {
      path: '/auto_pay_sections/add',
      name: 'auto_pay_sections.add',
      component: () => import('@/views/AutoPaySection/Form/AutoPaySectionForm.vue'),
      props: {addAction: true}
    },
    {
      path: '/auto_pay_sections/edit/:id',
      name: 'auto_pay_sections.edit',
      component: () => import('@/views/AutoPaySection/Form/AutoPaySectionForm.vue'),
      props: {updateAction: true}
    },
    {
      path: '/auto_pay_sections/delete/:id',
      name: 'auto_pay_sections.delete',
      component: () => import('@/views/AutoPaySection/Form/AutoPaySectionForm.vue'),
      props: {deleteAction: true}
    },
    {
      path: '/auto_pay_sections/view/:id',
      name: 'auto_pay_sections.view',
      component: () => import('@/views/AutoPaySection/Form/AutoPaySectionForm.vue'),
      props: {viewAction: true}
    }
  ],
}